export const env = {
    nodeEnv: import.meta.env.VITE_NODE_ENV || "development",
    apiBaseUrl:
        import.meta.env.VITE_API_BASE_URL || "http://localhost:4000/api/v1",
    supportPhone: import.meta.env.VITE_SUPPORT_PHONE || "918800123456",
    isDevelopment: import.meta.env.VITE_NODE_ENV !== "production",
    isProduction: import.meta.env.VITE_NODE_ENV === "production",
} as const;
